var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.6595,
    height: 45.6595,
    rx: 22.8297,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2446 29.2446C28.8713 29.618 28.4809 29.8046 28.0736 29.8046C27.6494 29.7877 27.2506 29.5925 26.8772 29.2192L22.7025 25.0444L18.6041 29.1428C18.2477 29.4992 17.8743 29.6858 17.484 29.7028C17.0767 29.7028 16.6949 29.5246 16.3385 29.1682C15.9821 28.8119 15.8124 28.4385 15.8294 28.0482C15.8294 27.6409 16.0076 27.2591 16.364 26.9027L20.4624 22.8043L16.4149 18.7568C16.0415 18.3835 15.8548 17.9931 15.8548 17.5858C15.8548 17.1785 16.05 16.7797 16.4403 16.3894C16.8137 16.0161 17.1955 15.8379 17.5858 15.8548C17.9931 15.8548 18.3835 16.0415 18.7568 16.4149L22.8043 20.4623L26.9027 16.364C27.276 15.9906 27.6579 15.8124 28.0482 15.8294C28.4385 15.8124 28.8119 15.9821 29.1683 16.3385C29.5246 16.6949 29.7028 17.0767 29.7028 17.484C29.7028 17.8574 29.5161 18.2307 29.1428 18.6041L25.0444 22.7025L29.2192 26.8772C29.5925 27.2506 29.7877 27.6494 29.8046 28.0736C29.8216 28.464 29.6349 28.8543 29.2446 29.2446Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fa81b2ef02bf3720116d4caa0262d0d3.svg";
export { ForwardRef as ReactComponent };